import { getContext } from '@picsart/miniapps-sdk';
import { setRefreshTokenFn } from '@picsart/cloud-storage/utils';

import { API_URL, REFRESH_TOKEN_URL, UNAUTHORIZED_STATUS_CODE, UPLOAD_API_URL } from 'config/api';

const backupFetch = window.fetch;

const context = getContext();

setRefreshTokenFn(async () => {
  await getContext().handlers.refreshToken();
  const headers = await new Promise(resolve => setTimeout(() => resolve(getContext().utils.api.getHeaders()), 50));
  return headers as Record<string, string>;
});

window.fetch = async (input: RequestInfo | URL, init?: RequestInit | undefined) => {
  // if not logged in, bypass
  if (!context.general.auth.getState().isAuthorized) return backupFetch(input, init);

  const isRequestObjectUsed = input instanceof Request;

  // destructing the request url
  const url = isRequestObjectUsed ? input.url : input.toString();

  if (url.includes(API_URL) || url.includes(UPLOAD_API_URL)) {
    // executing actual request to the backend service
    const actualRequest = backupFetch(input, init);

    const result = await actualRequest;

    // trying to refresh the token on unauthorized status code
    if (!result.ok && result.status === UNAUTHORIZED_STATUS_CODE && !result.url.includes(REFRESH_TOKEN_URL)) {
      if (getContext().utils.api.getHeaders()?.Authorization === (init?.headers as Record<string, string>)?.Authorization) {
        await context.handlers.refreshToken();
      }

      const headers = getContext().utils.api.getHeaders();
      return backupFetch(input, { ...init, headers: { ...init?.headers, ...headers } });
    }

    // if the request is successful, we will not try to refresh the access token
    return result;
  }

  // if is not from our backend service bypass
  return backupFetch(input, init);
};
